<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted() {
    const version = process.env.VUE_APP_BASE_VERSION
    console.warn('北京中石油可视化报表，当前版本：', version)
  }
}
</script>

<style lang="scss" scoped>
#app {
  width: 100vw;
  height: 100vh;
  //background-color: #020308;
  overflow: hidden;
}
</style>
